import { FETCH_LABELS, FETCH_STATIC_PAGE } from './types'
import labels from 'common/labels'
import { objectReducer, objectMap } from 'utils'

const initial = { page: {} }

const page = objectReducer(FETCH_STATIC_PAGE)

const translations = objectReducer(FETCH_LABELS, initial, {
  fetch: () => initial,
  success: translations => objectMap(labels, key => translations[key]),
  extra: (state, action) => {
    if (action.type.includes(FETCH_STATIC_PAGE)) {
      return { ...state, page: { ...state.page, [action.key]: page({}, action) } }
    }
    return state
  },
})

export default translations
